export const BASE_URL = 'http://localhost:4000/v1';
